import { StyleDeclarationValue, css } from 'aphrodite';
import { observer } from 'mobx-react';
import * as React from 'react';
import { IAggregateActiveUse } from '../../../../models/AdminModels';
import { getDisplayName } from '../../../../models/NameUtils';
import { styleSheet } from './styles';

interface IProps {
	className?: string;
	styles?: StyleDeclarationValue[];
	activeUse: IAggregateActiveUse;
}

class _ReportRowPerson extends React.Component<IProps> {
	public render() {
		const { className, styles, activeUse } = this.props;
		const validTotalPercent =
			activeUse?.activeAccountsPercentage >= 0 ? activeUse.activeAccountsPercentage.toLocaleString() + '%' : '??%';
		const validGreenPercent =
			activeUse?.greenAccountsPercentage >= 0 ? activeUse.greenAccountsPercentage.toLocaleString() + '%' : '??%';
		const validYellowPercent =
			activeUse?.yellowAccountsPercentage >= 0 ? activeUse.yellowAccountsPercentage.toLocaleString() + '%' : '??%';
		const validOrangePercent =
			activeUse?.orangeAccountsPercentage >= 0 ? activeUse.orangeAccountsPercentage.toLocaleString() + '%' : '??%';
		const validRedPercent =
			activeUse?.redAccountsPercentage >= 0 ? activeUse.redAccountsPercentage.toLocaleString() + '%' : '??%';

		return (
			<div className={`${css(styleSheet.container, ...(styles || []))} report-row-person ${className || ''}`}>
				<div className={css(styleSheet.textContainer)}>
					<div className={css(styleSheet.name)}>{getDisplayName(activeUse?.user)}</div>
					<div className={css(styleSheet.percent, styleSheet.bold)}>{validTotalPercent}</div>
					<div className={css(styleSheet.percent)}>{validGreenPercent}</div>
					<div className={css(styleSheet.percent)}>{validYellowPercent}</div>
					<div className={css(styleSheet.percent)}>{validOrangePercent}</div>
					<div className={css(styleSheet.percent)}>{validRedPercent}</div>
				</div>
			</div>
		);
	}
}

export const ReportRowPerson = observer(_ReportRowPerson);
